import React, { useState } from "react";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import { get } from "lodash";
import api from "APP_ROOT/api";
import {
  useCurrentUser,
  useDispatch,
  useScrollToOnMount
} from "APP_ROOT/hooks";
import { Errors, Form as AppForm } from "MODULES/shared/components/Forms";
import * as actions from "MODULES/ManagedRepairOrders/actions";
import LineItemForm from "MODULES/parts/components/Detail/ManagedRepairOrders/CreateManagedRepair/LineItemForm";
import { DOM_LIFE_YEARS, LLP } from "MODULES/parts/constants";
import { initialValues } from "MODULES/ManagedRepairOrders/helpers";
import styles from "../../styles";

export default function CreateLineItem({ close, part, managedRepairOrder }) {
  const scrollToRef = useScrollToOnMount();
  const currentUser = useCurrentUser();
  const { onSubmit, onCancel, setSubmittedWith } = useOnSubmit(
    managedRepairOrder,
    close
  );
  const lineItem = part && { part, part_id: part.id };
  const [selectedPart, setSelectedPart] = useState(part);
  const domLifeYears = get(part, DOM_LIFE_YEARS);
  const llp = get(part, LLP);

  return (
    <div
      className="panel panel-default"
      style={styles.container}
      ref={scrollToRef}
    >
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Add Part to Managed Repair
        </h4>
        <LineItemForm
          close={close}
          initialValues={initialValues(
            lineItem,
            currentUser,
            managedRepairOrder
          )}
          managedRepairOrder={managedRepairOrder}
          selectedPart={selectedPart}
          setSelectedPart={setSelectedPart}
          showBuyers={false}
          domLifeYears={domLifeYears}
          llp={llp}
          lineItem={lineItem}
          id={managedRepairOrder.id}
          shippingType={managedRepairOrder.ship_to_type}
          onSubmit={onSubmit}
          modalMode={false}
          renderFooter={formProps => (
            <AppForm.Footer>
              {formProps.submitFailed && (
                <Errors errors={formProps.errorMessages} />
              )}
              <AppForm.Cancel close={onCancel} editable />
              <AppForm.Submit
                disabled={false}
                editable
                submitting={formProps.submitting}
                onClick={() => setSubmittedWith("save")}
              />
              <AppForm.Submit
                disabled={false}
                editable
                submitting={formProps.submitting}
                text="Save and Go To Managed Repair"
                onClick={() => setSubmittedWith("save-and-go")}
              />
            </AppForm.Footer>
          )}
        />
      </div>
    </div>
  );
}

CreateLineItem.propTypes = {
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({}),
  managedRepairOrder: PropTypes.shape({})
};

// Custom hooks
function useOnSubmit(mro, close) {
  const dispatch = useDispatch();
  const [submittedWith, setSubmittedWith] = useState(null);

  const onCancel = () => {
    close();
    api.managedRepairOrders.cancel(mro.id, "cancelled_by_tenant");
  };

  const onSubmit = data =>
    dispatch(
      actions.addLineItem(data, mro.id, () => {
        if (submittedWith === "save-and-go") {
          dispatch(push({ pathname: `/managed-repair-orders/${mro.uuid}` }));
        } else {
          window.scrollTo(0, 0);
          close();
        }
      })
    );

  return {
    onSubmit,
    onCancel,
    setSubmittedWith
  };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/ManagedRepairOrders/CreateManagedRepair/CreateLineItem.jsx